import { StatusPill } from "./StatusPill";

export const ResultsTable = ({ rows }) => (
  <section data-testid="results-table" className="mt-24">
    <div className="flex items-baseline justify-between mb-5">
      <h2 className="section-title">Results log</h2>
      <span className="meta">last {rows.length} / 50 · in-memory</span>
    </div>
    <div className="table-wrap">
      <table className="w-full">
        <thead>
          <tr>
            <th>connector</th><th>status</th><th>http</th><th>latency</th><th>error</th><th>timestamp</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && (
            <tr><td colSpan={6} className="text-center py-10 text-[var(--muted)]">No runs yet.</td></tr>
          )}
          {rows.map((r) => (
            <tr key={r.id} data-testid={`results-row-${r.connector}`}>
              <td className="whitespace-nowrap">{r.label}</td>
              <td><StatusPill status={r.status} /></td>
              <td>{r.http_status ?? "n/a"}</td>
              <td className="whitespace-nowrap">{r.latency_ms} ms</td>
              <td className="err-cell">{r.error || "—"}</td>
              <td className="whitespace-nowrap text-[var(--muted)]">{new Date(r.timestamp).toLocaleTimeString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </section>
);
